<router-outlet></router-outlet>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<app-banner-nueva-version></app-banner-nueva-version>
